import ResourceService from "./resource.service";

class BrandService extends ResourceService {
  static get resource() {
    return "make";
  }
}

export default BrandService;
